import axios from 'axios';

// Anexa um arquivo (documento lido na importação) ao cliente já salvo, na lista de documentos dele.
// Retorna true se anexou. Não lança: quem chama decide o que avisar, e o cadastro em si já foi salvo.
export async function anexarDocumentoCliente(apiBaseUrl, idCliente, arquivo, authHeader) {
  if (!arquivo || !idCliente) return false;
  const formData = new FormData();
  formData.append('file', arquivo);
  formData.append('idCliente', idCliente);
  try {
    await axios.post(`${apiBaseUrl}/arquivos/upload-cliente`, formData, authHeader);
    return true;
  } catch (error) {
    console.error('Erro ao anexar documento ao cliente:', error);
    return false;
  }
}

// Anexa um arquivo (documento lido na importação, como o CRLV) ao veículo já salvo. Mesmo contrato do cliente.
export async function anexarDocumentoVeiculo(apiBaseUrl, idVeiculo, arquivo, authHeader) {
  return (await anexarDocumentoVeiculoComMotivo(apiBaseUrl, idVeiculo, arquivo, authHeader)).ok;
}

// O veículo já tem um documento com este nome? Reimportar o mesmo CRLV é comum — o cliente reenvia, ou
// o lote é repetido por garantia — e sem esta checagem cada repetição vira mais uma cópia, consumindo
// espaço do plano de armazenamento e poluindo a lista de documentos do veículo.
// Na dúvida (erro de rede, resposta estranha) devolve false: é melhor um anexo repetido do que perdido.
export async function veiculoJaTemDocumento(apiBaseUrl, idVeiculo, nomeArquivo, authHeader) {
  if (!idVeiculo || !nomeArquivo) return false;
  const alvo = String(nomeArquivo).trim().toLowerCase();
  const anexos = await documentosDoVeiculo(apiBaseUrl, idVeiculo, authHeader);
  return anexos.some((a) => String(a.nomeOriginal || '').trim().toLowerCase() === alvo);
}

// Os documentos já anexados ao veículo (lista vazia se não houver ou se a consulta falhar)
export async function documentosDoVeiculo(apiBaseUrl, idVeiculo, authHeader) {
  if (!idVeiculo) return [];
  try {
    const { status, data } = await axios.get(`${apiBaseUrl}/arquivos/veiculo/${idVeiculo}`, authHeader);
    return status === 204 || !Array.isArray(data) ? [] : data;
  } catch (error) {
    console.error('Erro ao consultar os documentos do veículo:', error);
    return [];
  }
}

// Remove um documento do cadastro. Devolve true se apagou.
export async function removerDocumento(apiBaseUrl, idArquivo, authHeader) {
  try {
    await axios.delete(`${apiBaseUrl}/arquivos/${idArquivo}`, authHeader);
    return true;
  } catch (error) {
    console.error('Erro ao remover o documento:', error);
    return false;
  }
}

// Igual à anterior, mas devolve { ok, motivo } com a recusa do servidor em vez de só "deu errado".
// O motivo importa ao anexar em lote: o upload pode parar no meio porque o plano de armazenamento
// encheu, e "não foi possível guardar" repetido quinze vezes não diz isso a ninguém.
export async function anexarDocumentoVeiculoComMotivo(apiBaseUrl, idVeiculo, arquivo, authHeader, exercicio) {
  if (!arquivo || !idVeiculo) return { ok: false, motivo: '' };
  const formData = new FormData();
  formData.append('file', arquivo);
  formData.append('idVeiculo', idVeiculo);
  // Marca o anexo como o CRLV daquele ano: é o que permite trocá-lo pelo do ano seguinte depois
  if (exercicio) formData.append('exercicio', exercicio);
  try {
    await axios.post(`${apiBaseUrl}/arquivos/upload`, formData, authHeader);
    return { ok: true, motivo: '' };
  } catch (error) {
    console.error('Erro ao anexar documento ao veículo:', error);
    // O ArquivoController devolve o texto da recusa no corpo (limite, assinatura do conteúdo, espaço do plano)
    const corpo = error.response?.data;
    const motivo = typeof corpo === 'string' ? corpo : (corpo?.message || error.message || '');
    return { ok: false, motivo };
  }
}
